<lx-price-lists-portal-price-and-note-table
  [company]="company"
  [dataSource]="dataSource"
  [columnLabels]="columnLabels"
></lx-price-lists-portal-price-and-note-table>
<lx-price-lists-portal-notes *ngIf="notes?.length > 0" [notes]="notes" [notationMarks]="notationMarks" [company]="company"></lx-price-lists-portal-notes>
